function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 30,
  fill: "#7643F5",
  opacity: 0.1
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#7643F5",
  d: "M26 16.67v-.003h14.664c.736 0 1.336.606 1.336 1.322v24.022c0 .35-.14.687-.388.935s-.585.387-.936.387H19.324c-.175 0-.348-.037-.51-.105-.16-.068-.307-.167-.43-.292-.123-.124-.22-.272-.286-.434-.066-.163-.1-.336-.098-.511V24.667l8-7.996zm-4.227 7.997H26V20.44l-4.227 4.227zm6.894-5.334V26c0 .354-.14.693-.39.943s-.59.39-.944.39h-6.666v13.334h18.666V19.333H28.667z"
});

function SvgReslist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReslist);
export default __webpack_public_path__ + "static/media/reslist.10bbc3df.svg";
export { ForwardRef as ReactComponent };